/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";

import ImageGallery from "react-image-gallery";
import ReactAudioPlayer from "react-audio-player";
import "react-image-gallery/styles/css/image-gallery.css";
import "@google/model-viewer";
import { Icon } from "@rsuite/icons";
import { SoundFilled } from "@ant-design/icons";
import * as S from "./styles";

export class ImageVideoGallery extends React.Component {
    constructor() {
        super();
        this.state = {
            showIndex: false,
            showBullets: true,
            infinite: true,
            showThumbnails: false,
            showFullscreenButton: true,
            showGalleryFullscreenButton: true,
            showPlayButton: false,
            showGalleryPlayButton: true,
            showNav: false,
            isRTL: false,
            slideDuration: 2000,
            slideInterval: 2000,
            slideOnThumbnailOver: false,
            thumbnailPosition: "bottom",
            showVideo: {},
            useWindowKeyDown: true,
            showAudioPlayer: false,
            startIndex: 0,
            autoPlayAudio: false,
            isFullScreen: true,
            autoPlay: false
        };
    }

    componentDidMount() { }

    componentDidUpdate() {
        let elements = document.getElementById("product-detail");
        console.log(`get element by id `, elements && elements?.length);
        let isElementPresent = elements && elements.length === 1;
        if (this.state.isFullScreen !== isElementPresent) {
            this.setState({ isFullScreen: isElementPresent });
        }
        const _resetVideo = () => {
            // console.log(`_reset video called`)
            if (this.state.showVideo && Object.keys(this.state.showVideo).length !== 0) {
                this._resetVideo(this);
            }

        }
        document.getElementById("product-detail")?.addEventListener("click", function (event) {
            // this._detectVideoClick();
            let videoDiv = document.getElementById("video-player");
            let audioDiv = document.getElementById("audio-player-one");
            let targetElement = event.target;
            // if (targetElement?.id !== videoDiv?.id) {
            //     _resetVideo();
            // }
            if (targetElement?.id !== audioDiv?.id) {
                audioDiv?.pause()
                // audioDiv.pause();
            }
        })

        document.getElementById("product-detail")?.addEventListener("touchmove", function (event) {
            console.log("event move",event)
            // this._detectVideoClick();
            let videoDiv = document.getElementById("video-player");
            let audioDiv = document.getElementById("audio-player-one");
            
            let targetElement = event.target;
            // if (targetElement?.id !== videoDiv?.id) {
            //     _resetVideo();
                
            // }
            if (targetElement?.id !== audioDiv?.id) {
                audioDiv?.pause()
                // audioDiv.pause();
            }
        })

    }

    _onSlide(index) {
        if (this.state.showAudioPlayer === true) {
            this.setState({ showAudioPlayer: false, startIndex: index });
        }
        this._resetVideo.bind(this);
    }

    _handleInputChange(state, event) {
        if (event.target.value > 0) {
            this.setState({ [state]: event.target.value });
        }
    }

    _handleCheckboxChange(state, event) {
        this.setState({ [state]: event.target.checked });
    }

    _handleThumbnailPositionChange(event) {
        this.setState({ thumbnailPosition: event.target.value });
    }

    _getStaticImages() {
        let images = [];
        for (let i = 2; i < 12; i++) {
            images.push({
                original: `${PREFIX_URL}${i}.jpg`,
                thumbnail: `${PREFIX_URL}${i}t.jpg`,
            });
        }

        return images;
    }

    _detectVideoClick = () => {
        document.addEventListener("click", (evnt) => {
            console.log(`clicked event lisner`, evnt);
            let videoDiv = document.getElementById("video-player");
            let targetElement = evnt.target;
            if (targetElement?.id !== videoDiv?.id) {
                this._resetVideo();
            }
        });
    };

    _resetVideo() {
        // console.log(`reset video main method`)
        this.setState({ showVideo: {} });
        if (this.state.showPlayButton) {
            this.setState({ showGalleryPlayButton: true });
        }

        if (this.state.showFullscreenButton) {
            this.setState({ showGalleryFullscreenButton: true });
        }
    }

    _toggleShowVideo(url, index) {
        this.state.showVideo[url] = !Boolean(this.state.showVideo[url]);

        this.setState({
            showVideo: this.state.showVideo,
            startIndex: index,
        });

        if (this.state.showVideo[url]) {
            if (this.state.showPlayButton) {
                this.setState({ showGalleryPlayButton: false });
            }

            if (this.state.showFullscreenButton) {
                this.setState({ showGalleryFullscreenButton: false });
            }
        }
    }

    handleAudioIconClick = (index) => {
        this.setState({
            showAudioPlayer: true,
            startIndex: index,
            autoPlayAudio: true,
        });
    };

    _renderAudioComp(index, item) {
        if (this.state && !this.state.showAudioPlayer) {
            return (
                <div className="video-wrapper">
                    <svg
                        aria-hidden="true"
                        onClick={() => this.handleAudioIconClick(index)}
                        focusable="true"
                        data-prefix="fas"
                        data-icon="play"
                        class="svg-inline--fa fa-play audio-icon"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                    >
                        <path
                            fill="#154a9f"
                            d="M176 480C148.6 480 128 457.6 128 432v-352c0-25.38 20.4-47.98 48.01-47.98c8.686 0 17.35 2.352 25.02 7.031l288 176C503.3 223.8 512 239.3 512 256s-8.703 32.23-22.97 40.95l-288 176C193.4 477.6 184.7 480 176 480z"
                        ></path>
                    </svg>
                </div>
            );
        }

        if (this.state && this.state.showAudioPlayer) {
            return (
                <div className="video-wrapper">
                    <ReactAudioPlayer
                        className={`audio-player`}
                        id={'audio-player-one'}
                        src={item.embedUrl}
                        controls
                    />
                </div>
            );
        }
    }

    _render3DItem(index, items) {
        return (
            <div className="video-wrapper">
                <model-viewer
                    style={{
                        height: `${this.state.isFullScreen ? "50rem" : "22rem"
                            }`,
                    }}
                    src={items?.src}
                    ios-src={items?.iosSrc}
                    poster={items?.poster}
                    alt={items?.alt}
                    shadow-intensity={items?.shadowIntensity}
                    camera-controls={items?.cameraControls}
                    auto-rotate
                    ar={items?.autoRotateAr}
                ></model-viewer>
            </div>
        );
    }

    _renderVideo(index, item) {
        return (
            <div id="video-player">
                {this.state.showVideo[item.embedUrl] ? (
                    <div className="video-wrapper">
                        <a
                            className="close-video"
                            onClick={this._toggleShowVideo.bind(
                                this,
                                item.embedUrl,
                                index
                            )}
                        ></a>
                        <S.IFrameContainer>
                            <S.IFrame
                                src={item.embedUrl}
                                frameBorder="0"
                                allowFullScreen={true}
                            />
                        </S.IFrameContainer>
                        {/* <iframe
                  width='100%'
                  height='100vh'
                  
                >
                </iframe> */}
                    </div>
                ) : (
                    <a
                        onClick={this._toggleShowVideo.bind(
                            this,
                            item.embedUrl,
                            index
                        )}
                    >
                        <div className="play-button"></div>
                        <img
                            id="video-player"
                            className="image-gallery-image"
                            src={item.original}
                        />
                        {item.description && (
                            <span
                                className="image-gallery-description"
                                style={{ right: "0", left: "initial" }}
                            >
                                {item.description}
                            </span>
                        )}
                    </a>
                )}
            </div>
        );
    }

    render() {
        const { images } = this.props;
        console.log(`bla in render outside:`, images)
        let _images =
            Array.isArray(images) &&
            images.map((item, index) => {
                if (item?.type === "3D") {
                    return {
                        ...item,
                        renderItem: this._render3DItem.bind(this, index),
                    };
                }

                if (item?.type === "audio") {
                    return {
                        ...item,
                        renderItem: this._renderAudioComp.bind(this, index),
                    };
                }

                if (item?.embedUrl && item?.type !== "audio") {
                    return {
                        ...item,
                        renderItem: this._renderVideo.bind(this, index),
                    };
                } else {
                    console.log(`bla in render:`, item)
                    return {
                        ...item,
                    };
                }
            });

        return (
            <section className="app" id="img-gallery">
                <ImageGallery
                    items={_images}
                    startIndex={this.state.startIndex}
                    onSlide={this._onSlide.bind(this)}
                    infinite={this.state.infinite}
                    showBullets={
                        _images && Array.isArray(_images) && _images?.length > 1 ? this.state.showBullets : false
                    }
                    showFullscreenButton={
                        this.state.showFullscreenButton &&
                        this.state.showGalleryFullscreenButton
                    }
                    showPlayButton={
                        _images && Array.isArray(_images) && _images?.length > 1
                            ? this.state.showPlayButton &&
                            this.state.showGalleryPlayButton
                            : false
                    }
                    showThumbnails={this.state.showThumbnails}
                    showIndex={this.state.showIndex}
                    showNav={this.state.showNav}
                    isRTL={this.state.isRTL}
                    thumbnailPosition={this.state.thumbnailPosition}
                    slideDuration={parseInt(this.state.slideDuration)}
                    slideInterval={parseInt(this.state.slideInterval)}
                    slideOnThumbnailOver={this.state.slideOnThumbnailOver}
                    additionalClass="app-image-gallery"
                    useWindowKeyDown={this.state.useWindowKeyDown}
                    autoPlay={this.state.autoPlay}
                />
            </section>
        );
    }
}
